import { GenericalRecord } from '../../types/utilities'

import { TableTransferCore } from './Core'
import { TransferRecord } from './Core/interface'
import { RemoteTransferProps } from './interface'
import { RemoteTransferStoreProvider } from './Store'

export const RemoteTransfer = <
  T extends GenericalRecord,
  P extends GenericalRecord,
  S
>({
  /* -------------------------------------------------------------------------- */
  /*                           RemoteTransferCore Props                         */
  /* -------------------------------------------------------------------------- */
  className,
  style,
  styles: externalStyles,
  disabled,
  oneWay,
  titles,
  showSearch,
  rowKey,
  height,
  leftSearchForm,
  leftColumns,
  rightColumns,
  rightFilterOption,
  leftFooter,
  rightFooter,
  /* -------------------------------------------------------------------------- */
  /*                       RemoteTransferStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: RemoteTransferProps<T & TransferRecord, P, S>) => {
  return (
    <RemoteTransferStoreProvider rowKey={rowKey} {...restProps}>
      <TableTransferCore
        className={className}
        disabled={disabled}
        height={height}
        leftColumns={leftColumns}
        leftFooter={leftFooter}
        leftSearchForm={leftSearchForm}
        oneWay={oneWay}
        rightColumns={rightColumns}
        rightFilterOption={rightFilterOption}
        rightFooter={rightFooter}
        rowKey={rowKey}
        showSearch={showSearch}
        style={style}
        styles={externalStyles}
        titles={titles}
      />
    </RemoteTransferStoreProvider>
  )
}
